import { AbstractDbCache } from './AbstractDbCache';

class TrainStepCache extends AbstractDbCache<'trainStep'> {
  protected getStoreName(): 'trainStep' {
    return 'trainStep';
  }
}

export default new TrainStepCache();
